
export const LOADING = "LOADING";

export const ERRORE_GENERICO_API = "ERRORE_GENERICO_API"
export const ERRORE_UNAUTHORIZED = "ERRORE_UNAUTHORIZED"
export const ERRORE_SESSION_EXPIRED = "ERRORE_SESSION_EXPIRED"
export const ERRORE_UNEXPECTED = "ERRORE_UNEXPECTED"
export const ERRORE_BLOCKING = "ERRORE_BLOCKING"
export const ERRORE_CHECK_SCREENING = "ERRORE_CHECK_SCREENING"
export const ERRORE_CAMPAGNA_INATTIVA = "ERRORE_CAMPAGNA_INATTIVA"
export const ERRORE_CUSTOM = "ERRORE_CUSTOM"
export const ECONNABORTED = "ECONNABORTED"

export const ERRORE_PAZIENTE_NON_TROVATO = "ERRORE_PAZIENTE_NON_TROVATO"
export const ERRORE_DATI_ERRATI = "ERRORE_DATI_ERRATI"
export const ERRORE_ASR = "ERRORE_ASR"
export const ERRORE_GENERICO_POSTLOGIN = "ERRORE_GENERICO_POSTLOGIN"

export const OPERATION_SUCCEDED = "OPERATION_SUCCEDED"

export const OPERATION_ERROR = "OPERATION_ERROR"
